var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportJdIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5068_6108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.34472 1.87239C7.37328 1.71946 7.45443 1.58133 7.57412 1.48193C7.6938 1.38254 7.84447 1.32812 8.00005 1.32812C8.15563 1.32812 8.3063 1.38254 8.42599 1.48193C8.54567 1.58133 8.62682 1.71946 8.65538 1.87239L9.35605 5.57772C9.40581 5.84115 9.53383 6.08347 9.7234 6.27304C9.91297 6.4626 10.1553 6.59062 10.4187 6.64039L14.1241 7.34106C14.277 7.36962 14.4151 7.45077 14.5145 7.57045C14.6139 7.69014 14.6683 7.84081 14.6683 7.99639C14.6683 8.15196 14.6139 8.30264 14.5145 8.42232C14.4151 8.54201 14.277 8.62316 14.1241 8.65172L10.4187 9.35239C10.1553 9.40215 9.91297 9.53017 9.7234 9.71974C9.53383 9.90931 9.40581 10.1516 9.35605 10.4151L8.65538 14.1204C8.62682 14.2733 8.54567 14.4114 8.42599 14.5108C8.3063 14.6102 8.15563 14.6647 8.00005 14.6647C7.84447 14.6647 7.6938 14.6102 7.57412 14.5108C7.45443 14.4114 7.37328 14.2733 7.34472 14.1204L6.64405 10.4151C6.59429 10.1516 6.46627 9.90931 6.2767 9.71974C6.08713 9.53017 5.84482 9.40215 5.58138 9.35239L1.87605 8.65172C1.72312 8.62316 1.58499 8.54201 1.4856 8.42232C1.3862 8.30264 1.33179 8.15196 1.33179 7.99639C1.33179 7.84081 1.3862 7.69014 1.4856 7.57045C1.58499 7.45077 1.72312 7.36962 1.87605 7.34106L5.58138 6.64039C5.84482 6.59062 6.08713 6.4626 6.2767 6.27304C6.46627 6.08347 6.59429 5.84115 6.64405 5.57772L7.34472 1.87239Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.33594V4.0026",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 2.66406H12",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99992 13.3333C3.99992 14.0697 3.40297 14.6667 2.66659 14.6667C1.93021 14.6667 1.33325 14.0697 1.33325 13.3333C1.33325 12.597 1.93021 12 2.66659 12C3.40297 12 3.99992 12.597 3.99992 13.3333Z",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5068_6108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportJdIcon);
export default __webpack_public_path__ + "static/media/importJD-icon.50c0eda3cf15d93b0bf6c2bc1bef29df.svg";
export { ForwardRef as ReactComponent };